import ResultCharts from "./ResultCharts";

export default ResultCharts;
